import { render, staticRenderFns } from "./comunicadosAdd.vue?vue&type=template&id=a09626f8&"
import script from "./comunicadosAdd.vue?vue&type=script&lang=js&"
export * from "./comunicadosAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports